
<application-edit [applicationId]="0"></application-edit>